module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_etgames_m.25f074d07e08be5a58763d3a34782560.png";